<template>
<div>
  <!-- <Header/> -->
  <Founder/>
  <Journey/>
  <OurTeachers/>
  <OurValues/>
  <TheBackground/>
  <MyCertificates/>
  <Footer/>
  
  </div>
</template>

<script>

import Footer from "../components/Partials/Footer.vue"
// import Header from "../components/Partials/Header.vue"
import Founder from "../components/AboutUs/Founder.vue"
import OurTeachers from "../components/AboutUs/OurTeachers.vue"
import OurValues from "../components/AboutUs/OurValues.vue"
import TheBackground from "../components/AboutUs/TheBackground.vue"
import MyCertificates from "../components/AboutUs/MyCertificates.vue"
import Journey from "../components/AboutUs/Journey.vue"

export default {
components:{
    Footer, Founder, OurTeachers, OurValues, TheBackground, MyCertificates, Journey
},
mounted () {
  window.scrollTo(0, 0)
  
}
}
</script>

<style>

</style>